// types
import type { AdditionalSelectors, HostActions } from '../types';

// store
import { MiddlewareManager } from './middlewareManager';
import { Selectors } from './selectors';

export let requestProposalSelectors: Selectors;
export let middlewareMgr: MiddlewareManager;

/**
 * Initializes the activity's store singletons with the host-provided selectors and host actions.
 * Called by the app shell's configureRequestProposal (mirrors dealership-picker init).
 */
export const init = (
    appName: string,
    additionalSelectors: AdditionalSelectors,
    hostActions: HostActions
): {
    selectors: Selectors;
    middlewareMgr: MiddlewareManager;
} => {
    requestProposalSelectors = new Selectors(appName, additionalSelectors);
    middlewareMgr = new MiddlewareManager(requestProposalSelectors, hostActions);

    return {
        selectors: requestProposalSelectors,
        middlewareMgr
    };
};
